export const INSTAGRAM_URL = "https://instagram.com/la.hausoflash";
export const INSTAGRAM_HANDLE = "@la.hausoflash";
export const OWNER_EMAIL = "hausoflash.la@gmail.com";

export const IMAGES = {
  hero: "/images/ig-2.jpg",
  extensions: "/images/ig-9.jpg",
  lifts: "/images/ig-12.jpg",
  instagram: [
    "/images/ig-1.jpg",
    "/images/ig-2.jpg",
    "/images/ig-3.jpg",
    "/images/ig-4.jpg",
    "/images/ig-5.jpg",
    "/images/ig-6.jpg",
  ],
};
